import { ReactNode, useEffect, useState } from 'react';
import { useParser } from '../../state/parser-hook';
import { useSiteContext } from '../../state/SiteContext';
import { services } from '../../globals';
import { useLangFilter, useValidityFilter } from '../../state/FilterContext';
import { useSystemPropertiesFilter } from '../../state/FilterContext';

interface RenderPathProps {
  path: string,
  ismain: boolean,
}

/***
 * A component that renders the contents of a specific path.
 * This can be used to render shared content which is not a part of the current page
 * and also not of the page wrapper.
 */
export function RenderPath({ path, ismain: _ismain }: RenderPathProps) {
  const parse = useParser();
  const { siteState } = useSiteContext();
  const validity = useValidityFilter();
  const system = useSystemPropertiesFilter();
  const lang = useLangFilter();

  const [url, setUrl] = useState<string>('');
  const [parsedHtml, setParsedHtml] = useState<ReactNode | null>(null);

  /***
   * Calculate URL for downloading file
   */
  useEffect(() => {
    if (siteState.site && path) {
      const newUrl: string = services.file.getDirectLink(
        siteState.site.name,
        path,
        validity,
        system,
        lang,
      );
      setUrl(newUrl);
    }
  }, [siteState.site, path, validity, system, lang]);

  /***
   * Reload file whenever the url changes
   */
  useEffect(() => {
    let didCancel = false;

    async function loadFile() {
      if (url && services) {
        const html: string = await services.file.getTextfile(url);
        if (!didCancel) {
          const parsedHtml = parse(html);
          setParsedHtml(parsedHtml);
        }
      }
    }

    loadFile();
    return () => { didCancel = true; };
  }, [url, parse])

  return <>{parsedHtml}</>;
}